export const DAILY_NAV_COMPANIES_TEST_IDS = {
  table: 'daily-nav-companies__table',
  enabledCheckbox: (companyId: number) => `daily-nav-companies__enabled-${companyId}`,
  thresholdInput: (companyId: number, fieldKey: string) =>
    `daily-nav-companies__threshold-${companyId}-${fieldKey}`,
  alexandriaButton: (companyId: number) => `daily-nav-companies__alexandria-${companyId}`,
  alexandriaDialog: 'daily-nav-companies__alexandria-dialog',
  companyLink: (companyId: number) => `daily-nav-companies__company-link-${companyId}`,
  noFirmConfigAlert: 'daily-nav-companies__no-firm-config-alert',
  navDayChip: (companyId: number) => `daily-nav-companies__nav-day-${companyId}`,
  applyButton: (companyId: number) => `daily-nav-companies__apply-${companyId}`,
  applyTooltip: (companyId: number) => `daily-nav-companies__apply-tooltip-${companyId}`,
  applyConfirmDialog: 'daily-nav-companies__apply-confirm-dialog',
  applyConfirmButton: 'daily-nav-companies__apply-confirm-button',
} as const;
